// extracted by mini-css-extract-plugin
module.exports = {"searchContentSection":"_1kv1j"};